/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from 'ngx-bootstrap/accordion/accordion.component';
import * as i2 from 'ngx-bootstrap/accordion/accordion.config';
const styles_AccordionComponent:any[] = ([] as any[]);
export const RenderType_AccordionComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_AccordionComponent,data:{}});
export function View_AccordionComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵncd((null as any),0)],(null as any),(null as any));
}
export function View_AccordionComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'accordion',[['class',
      'panel-group'],['role','tablist'],['style','display: block']],[[1,'aria-multiselectable',
      0]],(null as any),(null as any),View_AccordionComponent_0,RenderType_AccordionComponent)),
      i0.ɵdid(49152,(null as any),0,i1.AccordionComponent,[i2.AccordionConfig],(null as any),
          (null as any))],(null as any),(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,1).closeOthers;
    _ck(_v,0,0,currVal_0);
  });
}
export const AccordionComponentNgFactory:i0.ComponentFactory<i1.AccordionComponent> = i0.ɵccf('accordion',
    i1.AccordionComponent,View_AccordionComponent_Host_0,{closeOthers:'closeOthers'},
    {},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL25neC1ib290c3RyYXAvYWNjb3JkaW9uL2FjY29yZGlvbi5jb21wb25lbnQubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvbm9kZV9tb2R1bGVzL25neC1ib290c3RyYXAvYWNjb3JkaW9uL2FjY29yZGlvbi5jb21wb25lbnQuZC50cyIsIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL25vZGVfbW9kdWxlcy9uZ3gtYm9vdHN0cmFwL2FjY29yZGlvbi9hY2NvcmRpb24uY29tcG9uZW50LmQudHMuQWNjb3JkaW9uQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9ub2RlX21vZHVsZXMvbmd4LWJvb3RzdHJhcC9hY2NvcmRpb24vYWNjb3JkaW9uLmNvbXBvbmVudC5kLnRzLkFjY29yZGlvbkNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxuZy1jb250ZW50PjwvbmctY29udGVudD4iLCI8YWNjb3JkaW9uPjwvYWNjb3JkaW9uPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7OzsyQkNBQTs7O29CQ0FBO01BQUE7TUFBQTthQUFBO1VBQUE7SUFBQTtJQUFBLFdBQUEsU0FBQTs7Ozs7In0=



// WEBPACK FOOTER //
// ./compiled/node_modules/ngx-bootstrap/accordion/accordion.component.ngfactory.ts